<template>
  <div>
    <h1>Crear Usuario</h1>
    <b-card >
      <ValidationObserver ref="form" >
        <b-form @submit.prevent="onSubmit">
          <Loading :active="loading" :is-full-page="true"></Loading>
          <div class="row">
            <div class="col-sm-4 col-md-4">
              <ValidationProvider name="Nombre" rules="required" v-slot="{ validated, valid }">
                <b-form-group
                  id="input-group-name"
                  label-for="name"
                  label="Nombre"
                  class="mb-0"
                >
                  <b-form-input v-model="user.name" id="name" placeholder="Nombre completo" :state="getState(validated, valid)"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="col-sm-4 col-md-4">
              <ValidationProvider name="Email" rules="required|email" v-slot="{ validated, valid }">
                <b-form-group
                  id="input-group-email"
                  label-for="email"
                  label="Email"
                  class="mb-0"
                >
                  <b-form-input v-model="user.email" id="email" placeholder="email@dominio.com" :state="getState(validated, valid)"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="col-sm-4 col-md-4">
              <ValidationProvider name="Password" rules="required" v-slot="{ validated, valid }">
                <b-form-group
                  id="input-group-password"
                  label-for="password"
                  label="Password"
                  class="mb-0"
                >
                  <b-form-input v-model="user.password" id="password" type="password" placeholder="xxxx" :state="getState(validated, valid)"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="col-sm-4 col-md-4">
              <ValidationProvider name="Role" rules="required" v-slot="{ validated, valid }">
                <b-form-group
                  id="input-group-role"
                  label-for="role"
                  label="Role"
                  class="mb-0"
                >
                  <b-form-select
                    id="select-role"
                    class="form-control"
                    v-model="user.role"
                    :state="getState(validated, valid)"
                  >
                    <b-select-option value="">Role</b-select-option>
                    <b-select-option v-for="p in roles" :key="p" :value="p">{{p}}</b-select-option>
                  </b-form-select>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="col-sm-4 col-md-4">
              <ValidationProvider name="Terminal" rules="required" v-slot="{ validated, valid }">
                <b-form-group
                  id="input-group-terminal"
                  label-for="terminal"
                  label="terminal"
                  class="mb-0"
                >
                  <b-form-select
                    id="select-terminal"
                    class="form-control"
                    v-model="user.terminal"
                    :state="getState(validated, valid)"
                  >
                    <b-select-option value="">Terminal</b-select-option>
                    <b-select-option v-for="p in terminals" :key="p" :value="p">{{p}}</b-select-option>
                  </b-form-select>
                </b-form-group>
              </ValidationProvider>
            </div>
          </div>
          <div v-if="errors" class="d-flex">
            <ul style="list-style-type:none;" class="p-0 m-0">
              <template v-for="(field, i) in errors">
                <li v-for="(m, index) in field" :key="i+index" class="text-danger">{{ m }}</li>
              </template>
            </ul>
          </div>
          <b-button @click="onSubmit" class="mt-3"  variant="primary">Guardar</b-button>
        </b-form>
      </ValidationObserver>
    </b-card>
  </div>
</template>
<script>
  import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
  import { required, email } from 'vee-validate/dist/rules'
  extend('email', email)
  extend('required', required)
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  export default {
    name:'CreateUser',
    components:{FontAwesomeIcon, ValidationObserver, ValidationProvider},
    props:{},
    data() {
      return {
        errors:null,
        loading:false,
        user:{
          name:'',
          email:'',
          password:'',
          role:'',
          terminal:'',
        },
        roles:['admin', 'supervisor', 'cashier', 'seller'],
        terminals:['T2','T3','T4',]
      }
    },
    methods: {
      getState(validated, valid) {
        if (!validated) {
          return null;
        }
        return valid
      },
      onSubmit(e) {
        e.preventDefault()
        this.errors = null
        this.$refs.form.validate().then((success) => {
          console.log('success', success);
          
          if (success) {
            this.loading = true
            const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/users`
            //this.$store.dispatch('quote/setRequest', this.rq)
            this.$axios.post(url, this.user).then(rs => {
              //this.$store.dispatch('quote/setData', rs.data)
              if (!rs.data.error) {
                window.location.href = url 
              } else {
                this.loading = false
              }
            })
            .catch(error=> {
              if (error.response) {
                this.errors = error.response.data.errors
              }  else {
                this.errors = {
                  unexpected: ['Hubo un error por favor contacte al administrador']
                }
              }
              console.log('error quote', error);
              this.loading = false
            })
          }
        })
        
      },
    }
  }
</script>